const Constants = {
  Login: {
    LOGIN_FAILED: "Login Failed"
  },
  Account: {
    MainErrorMessage: {
      VALIDATE_ACCOUNT_FAILED: "Invalid Account"
    },
    SecondaryErrorMessage: {
      ACCOUNT_NOT_ACTIVE: "Account Not Active",
      ACCOUNT_VIOLATED: "Account Locked"
    },
    LinkToFix: {
      ACCOUNT_NOT_ACTIVE: "Account Not Active",
      ACCOUNT_VIOLATED: "Account Locked"
    },
    SuccessMessage: {
      ACCOUNT_VALID: "Account Active"
    }
  },
  Post: {
    MainErrorMessage: {
      POST_DOESNT_EXIST: "Post Does Not Exist",
      PENDING_POST: "Post Pending",
    },
    SecondaryErrorMessage: {
      POST_NOT_LIVE: "Post is still in the pending revision state",
      POST_UNPUBLISHED: "Please publish your post"
    },
    LinkToFix: {
      POST_NOT_LIVE: "Post is still in the pending revision state",
      POST_UNPUBLISHED: "Please publish your post"
    },
    SuccessMessage: { POST_LIVE: "Post Is Live" }
  },
  Image: {
    MainErrorMessage: {
      IMAGE_FOUND: "No post found but an image has been found"
    },
    SecondaryErrorMessage: {
      REPOST: "Please try pasting the HTML code again"
    },
    LinkToFix: {
      REPOST: ""
    },
    SuccessMessage: { BLOG_FOUND: "Blog found" }
  },
  DOM: {
    MainErrorMessage: { SCRIPT_TAG_FAILED: "Script Tag Failed" },
    SecondaryErrorMessage: {
      SCRIPT_TAG_CONTAINS_HEADER_TAG:
        "Script Tag is surrounded by a header tag",
      SCRIPT_TAG_CONTAINS_P_TAG: "Script Tag is surrounded by a p tag",
      SCRIPT_TAG_CONTAINS_A_TAG: "Script Tag is surrounded by an a tag",
      SCRIPT_TAG_CONTAINS_UNORDEREDLIST_TAG:
        "Script Tag is surrounded by a ul tag",
      SCRIPT_TAG_CONTAINS_BOLD_TAG: "Script Tag is surrounded by a bold tag",
      SCRIPT_TAG_CONTAINS_ITALIC_TAG:
        "Script Tag is surrounded by an italic tag",
      SCRIPT_TAG_NOT_FOUND: "Script Tag not found",
      BLOG_NOT_FOUND: "Blog not found",
      SCRIPT_TAG_IN_CODE_TAG:
        "Your pasted HTML is currently inside of a Code Block instead of a HTML Block",
      SCRIPT_TAG_IN_CLASSIC_EDITOR:
        "Your pasted HTML is pasted as plain text but it should be inside of a HTML Block"
    },
    LinkToFix: {
      SCRIPT_TAG_CONTAINS_HEADER_TAG:
        "Script Tag is surrounded by a header tag",
      SCRIPT_TAG_CONTAINS_P_TAG: "Script Tag is surrounded by a p tag",
      SCRIPT_TAG_CONTAINS_A_TAG: "Script Tag is surrounded by an a tag",
      SCRIPT_TAG_CONTAINS_UNORDEREDLIST_TAG:
        "Script Tag is surrounded by a ul tag",
      SCRIPT_TAG_CONTAINS_BOLD_TAG: "Script Tag is surrounded by a bold tag",
      SCRIPT_TAG_CONTAINS_ITALIC_TAG:
        "Script Tag is surrounded by an italic tag",
      SCRIPT_TAG_NOT_FOUND: "Script Tag not found",
      BLOG_NOT_FOUND: "Blog not found",
      SCRIPT_TAG_IN_CODE_TAG:
        "Your pasted HTML is currently inside of a Code Block instead of a HTML Block"
    },
    SuccessMessage: { SCRIPT_TAG_VALID: "Script Tag is valid" }
  },
  Ajax: {
    MainErrorMessage: { AJAX_LOADING_FOUND: "Ajax Loading Found and has to be disabled" },
    SecondaryErrorMessage: {
      THEME_NOT_FOUND: "Theme not found",
      SKYE: "Skye Theme Found",
      BRINE: "Brine Theme Found",
      FARRO: "Farror Theme Found",
      TREMONT: "Tremont Theme Found",
      YORK: "York Theme Found"
    },
    LinkToFix: {
      THEME_NOT_FOUND: "Theme not found",
      SKYE: "Skye Theme Found",
      BRINE: "Brine Theme Found",
      FARRO: "Farror Theme Found",
      TREMONT: "Tremont Theme Found",
      YORK: "York Theme Found"
    },
    SuccessMessage: { VALID_THEME: "Valid Theme" }
  }
};
export default Constants;
